import { render } from "./VideoDialog.vue?vue&type=template&id=2d725aa8&scoped=true"
import script from "./VideoDialog.vue?vue&type=script&lang=js"
export * from "./VideoDialog.vue?vue&type=script&lang=js"

import "./VideoDialog.vue?vue&type=style&index=0&id=2d725aa8&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d725aa8"]])

export default __exports__